let samplePack = []
let sampleCarousel = false

bindSampleItems = () => {
  let modal = document.querySelector(".visualizer-modal")
  let samples = document.querySelectorAll(".is-sample:not(.bound)")

  samples.forEach(sample => {
    // bind
    sample.classList.add("bound")

    // setup pattern hotswap & visualizer toggle
    let trigger = sample.querySelector(".js-visualize-sample")

    trigger.addEventListener("click", () => {
      let imgUrl = sample.querySelector(".variant-images img").getAttribute("src")
      //set pattern
      roomComparison.hotSwapPattern(imgUrl)
      //open
      gsap.to(modal, { autoAlpha: 1, duration: 0.4, ease: Sine.easeOut })

      if ($scroll) {
        $scroll.lockScroll()
      }
    })

    let sampleButtons = sample.querySelectorAll(".add-to-pack");

    Array.prototype.slice.call(sampleButtons).forEach((btn) => {

      if (!hasClass(btn, "bound")) {

        btn.classList.add("bound");
        btn.addEventListener("click", () => {
          let id_ = btn.getAttribute("data-id");
          let handle_ = btn.getAttribute("data-handle");
          let imgUrl = sample.querySelector(".variant-images img").getAttribute("src")
          // console.log("src:", imgUrl)

          if (hasClass(btn, "clicked")) {
            btn.classList.remove("clicked")
            //remove sample
            removeFromPack({
              id: id_,
              handle: handle_,
              img: imgUrl
            })
          } else {
            btn.classList.add("clicked")
            //add sample to group
            addToPack({
              id: id_,
              handle: handle_,
              img: imgUrl
            });
          }
        });
      }
    });
  })
}

setupVisualizerModal = () => {
  let modal = document.querySelector(".visualizer-modal")


  let closeTriggers = document.querySelectorAll(".js-visualizer-close")

  closeTriggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      //close
      gsap.to(modal, { autoAlpha: 0, duration: 0.4, ease: Sine.easeOut })

      if ($scroll) {
        $scroll.unlockScroll()
      }
    })
  })
}

let addToPack = (packObj) => {
  let track = document.querySelector(".js-sample-track")
  let idx = samplePack.length

  let addPackToBagBtn = document.querySelector(".js-add-sample-group")
  addPackToBagBtn.classList.remove("disabled")

  samplePack.push(packObj)

  // console.log("sample pack:", samplePack)

  // get length of sample pack :
  if (samplePack.length <= (isMobile() ? 6 : 5)) {
    // if it's <= 5 (6 mobile), modify an empty cell
    let item = Array.prototype.slice.call(track.querySelectorAll(".pencil-bar__carousel-item"))[idx]
    item.className = "pencil-bar__carousel-item"

    item.innerHTML = `
            <div class="pencil-bar__carousel-image" style="background-image: url('${packObj.img}');"></div>
            <div class="pencil-bar__carousel-remove js-carousel-remove"></div>
        `

    item.setAttribute("data-id", packObj.id)
    item.setAttribute("data-handle", packObj.handle)
    item.setAttribute("data-img", packObj.img)

    item.querySelector(".js-carousel-remove").addEventListener("click", () => {
      // console.log(item.dataset)
      removeFromPack(item.dataset)
    })
  } else {
    // if it's > 5 (6 mobile), append a child
    let item = document.createElement("div")
    item.className = "pencil-bar__carousel-item"

    item.innerHTML = `
            <div class="pencil-bar__carousel-image" style="background-image: url('${packObj.img}');"></div>
            <div class="pencil-bar__carousel-remove js-carousel-remove"></div>
        `

    item.setAttribute("data-id", packObj.id)
    item.setAttribute("data-handle", packObj.handle)
    item.setAttribute("data-img", packObj.img)

    item.querySelector(".js-carousel-remove").addEventListener("click", () => {
      // console.log(item.dataset)
      removeFromPack(item.dataset)
    })

    track.appendChild(item)
  }

  // add to pencil bar, re-bind
  bindPencilCarousel()
  displayPackLength()
}

let removeFromPack = (packObj) => {
  let track = document.querySelector(".js-sample-track")
  let addPackToBagBtn = document.querySelector(".js-add-sample-group")

  let idx = samplePack.findIndex(el => {
    return el.id == packObj.id
  })

  samplePack = remove(samplePack, samplePack[idx])

  // console.log("sample pack:", samplePack)
  // remove the child node
  let node = track.querySelector("[data-id='" + packObj.id + "']")

  track.removeChild(node)

  // get length of sample pack :
  if (samplePack.length < (isMobile() ? 6 : 5)) {
    // if it's < 5 (6 mobile), add an empty cell
    let item = document.createElement("div")
    item.className = "pencil-bar__carousel-item pencil-bar__carousel-item--empty"

    track.appendChild(item)
  }

  document.querySelector(".button[data-id='" + packObj.id + "']").classList.remove("clicked")

  if (samplePack.length == 0) {
    addPackToBagBtn.classList.add("disabled")
  }

  bindPencilCarousel()

  displayPackLength()
}

let bindPencilCarousel = () => {
  if (isMobile()) return

  if (!sampleCarousel) {
    let container = document.querySelector(".js-sample-carousel")
    let leftBtn = document.querySelector(".js-sample-left")
    let rightBtn = document.querySelector(".js-sample-right")

    sampleCarousel = new Glide(container, {
      type: 'slider',
      gap: 14,
      perView: 5,
      peek: 0
    });
    sampleCarousel.mount();

    leftBtn.addEventListener("click", () => {
      if (sampleCarousel.index > 0) {
        sampleCarousel.go("<")
      }
    })

    rightBtn.addEventListener("click", () => {
      if (samplePack.length > 5 && sampleCarousel.index < samplePack.length - 5) {
        sampleCarousel.go(">")
      }
    })
  } else {
    sampleCarousel.update()
  }
}

let clearPack = () => {
  let track = document.querySelector(".js-sample-track")
  samplePack = []

  track.innerHTML = "";

  let numEmptyCells = globalStorage.isMobile ? 6 : 5;

  for (let i = 0; i < numEmptyCells; i++) {
    let item = document.createElement("div")
    item.className = "pencil-bar__carousel-item pencil-bar__carousel-item--empty"

    track.appendChild(item)
  }

  let clickedBtns = Array.prototype.slice.call(document.querySelectorAll(".is-sample .button.clicked"))

  clickedBtns.forEach(btn => {
    btn.classList.remove("clicked")
  })

  displayPackLength()
}

let displayPackLength = () => {
  let text = document.querySelector(".js-sample-pencil h2")

  if (samplePack.length > 0) {
    if (samplePack.length > 1) {
      text.innerHTML = samplePack.length + " Samples Selected"
    } else {
      text.innerHTML = samplePack.length + " Sample Selected"
    }
  } else {
    text.innerHTML = "No Samples Selected"
  }
}

let initAddPackToBagBtn = () => {
  let btn = document.querySelector(".js-add-sample-group")

  btn.addEventListener("click", () => {
    let packIds = samplePack.map(packObj => {
      return packObj.id
    })

    let packHandles = samplePack.map(packObj => {
      return packObj.handle
    })

    addSample(packIds, packHandles)

    closeMobilePencil()
    clearPack()
  })
}

let closeMobilePencil = () => {
  if (!globalStorage.isMobile) return

  let pencil = document.querySelector(".js-sample-pencil")
  let bar = pencil.querySelector(".js-sample-pencil-bar")
  let bg = pencil.querySelector(".js-pencil-bar-close")

  pencil.classList.remove("open")
  gsap.to(bar, { yPercent: 100, y: -55, duration: 0.8, ease: Expo.easeOut })
  gsap.to(bg, { autoAlpha: 0, duration: 0.8, ease: Expo.easeOut })

  if ($scroll) {
    $scroll.unlockScroll()
  }
}

addSample = (ids, handles) => {

  let obj = {};

  obj.type = "add-to-cart";
  obj.token = "add-to-cart";
  obj.checkout = globalStorage.checkout;

  let items = ids.map((id) => {
    return {
      id: id,
      quantity: 1
    }
  });
  let formData = {
    'items': items
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    window.SLIDECART_UPDATE();
    window.SLIDECART_OPEN();
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });

  return;
}

initSamples = () => {

  let sampleButtons = document.getElementsByClassName("add-sample");

  Array.prototype.slice.call(sampleButtons).forEach((btn) => {

    if (!hasClass(btn, "bound")) {

      btn.classList.add("bound");
      btn.addEventListener("click", () => {

        let id = btn.getAttribute("data-id");
        let handle = btn.getAttribute("data-handle");
        let array = [id];
        let handles = [handle];
        addSample(array, handles);
      });
    }
  });
};